export default "__VITE_ASSET__DWZo2MWU__"